<template>
	<div class="countries">
		<h3 class="countries__title">{{$t('prebets.countries')}}</h3>
		<page-error
			v-show="!countries || (loaded && countries.length === 0)"
			:message="$t('general.no-countries-found-please-refresh-your-page')"
		>
			<button slot="action" @click="getCountries">{{$t('prebets.countries')}}</button>
		</page-error>
		<basic-list-loader v-if="!loaded" />
		<div class="countries__list" v-show="!selectedCountry">
			<div
				class="countries__section__group"
				v-for="country in countries"
				:key="country.category_id"
			>
				<b-button
					class="countries__section__button full no-bg icon"
					@click="selectedCountry = country"
				>
					<span style="display: flex; flex-direction: row; align-items: center">
						<img
							style="margin-right: 10px"
							width="25px"
							:src="getImageSrc(country.category_name)"
							@error="onImageError"
						/>
						{{ country.category_name || "World" }} ({{
							country.competitions.length
						}})
					</span>

					<svg
						width="9"
						height="13"
						class="button__caret"
						viewBox="0 0 9 13"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7.79297 7.21484C7.92969 7.10547 8.01172 6.94141 8.01172 6.75C8.01172 6.58594 7.92969 6.42188 7.79297 6.28516L2.48828 0.980469C2.35156 0.871094 2.1875 0.789062 2.02344 0.789062C1.83203 0.789062 1.66797 0.871094 1.55859 0.980469L0.957031 1.58203C0.820312 1.71875 0.738281 1.88281 0.738281 2.04688C0.738281 2.23828 0.792969 2.40234 0.929688 2.51172L5.16797 6.75L0.929688 10.9883C0.792969 11.125 0.738281 11.2891 0.738281 11.4531C0.738281 11.6445 0.820312 11.8086 0.957031 11.918L1.55859 12.5195C1.66797 12.6562 1.83203 12.7109 2.02344 12.7109C2.1875 12.7109 2.35156 12.6562 2.48828 12.5195L7.79297 7.21484Z"
						/>
					</svg>
				</b-button>
			</div>
		</div>
		<div class="countries__detail" v-if="selectedCountry">
			<div
				class="countries__section__button__group"
				v-for="competition in selectedCountry.competitions"
				:key="competition.competition_id"
			>
				<router-link
					class="button countries__section__button full no-bg icon"
					:to="{
						name: 'sport-competition',
						params: {
							sportName: $options.filters.seoText(selectedSport.sport_name),
							competitionName: getCompetitionName(selectedCountry, competition),
						},
					}"
				>
					<span style="display: flex; flex-direction: row; align-items: center">
						<img
							style="margin-right: 10px"
							width="25px"
							:src="getImageSrc(selectedCountry.category_name)"
							@error="onImageError"
						/>
						{{ competition.competition_name }} ({{ competition.count }})
					</span>
					<svg
						width="9"
						height="13"
						class="button__caret"
						viewBox="0 0 9 13"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7.79297 7.21484C7.92969 7.10547 8.01172 6.94141 8.01172 6.75C8.01172 6.58594 7.92969 6.42188 7.79297 6.28516L2.48828 0.980469C2.35156 0.871094 2.1875 0.789062 2.02344 0.789062C1.83203 0.789062 1.66797 0.871094 1.55859 0.980469L0.957031 1.58203C0.820312 1.71875 0.738281 1.88281 0.738281 2.04688C0.738281 2.23828 0.792969 2.40234 0.929688 2.51172L5.16797 6.75L0.929688 10.9883C0.792969 11.125 0.738281 11.2891 0.738281 11.4531C0.738281 11.6445 0.820312 11.8086 0.957031 11.918L1.55859 12.5195C1.66797 12.6562 1.83203 12.7109 2.02344 12.7109C2.1875 12.7109 2.35156 12.6562 2.48828 12.5195L7.79297 7.21484Z"
						/>
					</svg>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import BasicListLoader from "../Shared/BasicListLoader.vue";
export default {
	name:"match-countries",
	components: { BasicListLoader },

	computed: {
		loaded() {
			return this.$store.getters.countriesLoaded;
		},
		countries() {
			return this.$store.getters.countries.data;
		},
		selectedSport() {
			return this.$store.getters.selectedSport;
		},
		selectedCompetition() {
			return this.$store.getters.selectedCompetition;
		}
	},
	data() {
		return {
			favorites: [],
			selectedCountry: null,
			page: 1,
			limit: 1000,
			total: 1000,
			error: false,
			loadingMore: false,
			countriesLocaleJson: {}
		};
	},
	mounted() {
		this.fetchCountryLocales()
	},
	methods: {
		getCompetitionFromUrl() {
			let competitionName = this.$route.params.competitionName;
			if (!competitionName)
				return {
					competition_id: null,
					competition_name: null,
				};
			let selectedCountry = this.$store.getters.countries.data.find(
				(country) => {
					return country.competitions.find((competition) => {
						return competition.urlSlug === competitionName;
					});
				}
			);
			let selectedCompetition = selectedCountry.competitions.find(
				(competition) => {
					return competition.urlSlug === competitionName;
				}
			);
			return selectedCompetition;
		},
		getCountries() {
			let vm = this;
			vm.$store.dispatch("getCountries").then((countries) => {
				vm.$store.commit("SET_COUNTRIES", countries);
				vm.$store.commit(
					"UPDATE_SELECTED_COMPETITION",
					vm.getCompetitionFromUrl()
				);
			});
		},
		getCompetitionName(country, competition) {
			return `${country.category_name
				.split(" ")
				.join("-")
				.toLowerCase()}-${competition.competition_name
				.split(" ")
				.join("-")
				.toLowerCase()
				.replace(/,/g, "")}`;
		},
		clearCompetition() {
			this.selectedCountry = null;
		},
		onImageError(e) {
			if (e.target.src != `${CDN_URL}country-flags/png-src/missing.png`) {
				e.target.src = `${CDN_URL}country-flags/png-src/missing.png`;
			}
		},
		getImageSrc(category) {
			
            if (!category) category = "missing";
			let country = category
				.toLowerCase()
				.replace(/\samateur/gi, "")
				.replace(/,/gi, "")
				.replace(/\s/g, "_")
				.replace(/\-/g, "_")
				
			let countryLocal = this.countriesLocaleJson[country]
			
            if(countryLocal){
				return `${CDN_URL}country-flags/png-src/${countryLocal}.png`;
            } else {
                return `${CDN_URL}country-flags/png-src/${country}.png`;
            }
            
		},
		async fetchCountryLocales(){
			await fetch(`${this.env.countriesLocaleBaseUrl + this.env.locale}.json`)
		        .then(r => r.json())
		        .then(countryLocaleJson => {
		            this.countriesLocaleJson = countryLocaleJson[this.env.locale]
		        });
		}
	},
};
</script>

<style lang="scss">
.countries {
	overflow-y: auto;
	position: relative;
	background: var(--white);
	color: var(--black);
	padding: 20px;
	width: calc(100% - 40px);
	&__list {
		padding-bottom: var(--padding-bottom);
	}
	&__title {
		margin: 0;
		margin-bottom: 10px;
	}
	&__section {
		display: flex;
		flex-direction: column;
		margin-bottom: 10px;
		&__title {
			margin: 0;
			color: var(--black);
			font-size: var(--font-large);
		}
		&__button {
			background: none;
			border: none;
			font-size: var(--font-medium);
			text-align: left;
			padding: 10px 0;

			&__group {
			}
		}
		&__dropdown {
		}
		&__group {
		}
	}
}
</style>
